{
  "course_analytics": {
    "title": "Bananalys",
    "filters": "Filter",
    "course": "Bana",
    "select_course": "Välj bana",
    "start_date": "Från",
    "end_date": "Till",
    "min_handicap": "Min HCP",
    "max_handicap": "Max HCP",
    "rounds": "rundor",
    "hole": "Hål",
    "par": "Par",
    "avg_score": "Snittscore",
    "difficulty": "Svårighet",
    "current_hcp": "HCP",
    "calculated_hcp": "Beräknat HCP",
    "hcp_diff": "Skillnad",
    "eagle_or_better": "Eagle eller bättre",
    "birdies": "Birdie",
    "pars": "Par",
    "bogeys": "Bogey",
    "double_or_worse": "Dubbelbogey eller sämre",
    "no_data": "Ingen data",
    "select_course_prompt": "Välj en bana för att visa analysdata",
    "round_type": "Rundtyp",
    "all_rounds": "Alla rundor",
    "competition_rounds": "Tävlingsrundor",
    "practice_rounds": "Övningsrundor",
    "search": "Sök",
    "eagle_short": "Eagle-",
    "birdie_short": "Birdie",
    "bogey_short": "Bogey",
    "double_short": "2Bogey+",
    "kicker": "Bananalys · Resultat",
    "period": "Period",
    "hcp_range": "Handikappintervall",
    "rounds_section": "Rundor",
    "hardest_hole": "Svåraste hålet",
    "easiest_hole": "Lättaste hålet",
    "quick_nav_meta": "Par {{par}} · snitt {{avg}}",
    "table_section": "Tabell",
    "table_hint": "alla {{count}} hål · klicka på en rad för att se fördelningen",
    "calculated_hcp_short": "Ber. HCP",
    "holes_section": "Hål",
    "n_count": "n={{count}}",
    "avg_vs_par": "Medelvärde i förhållande till par",
    "distribution": "Fördelning",
    "difficulty_total": "Svårighet tot.",
    "export_pdf": "Ladda ner PDF",
    "pdf_page": "Sida {{page}} / {{pages}}",
    "pdf_table_meta": "alla {{count}} hål",
    "pdf_hcp_all": "Ingen begränsning"
  },
  "admin_dashboard": {
    "title": "Analys",
    "overview": "Översikt",
    "totalUsers": "Användare totalt",
    "roundsCompleted": "Rundor",
    "competitions": "Tävlingar",
    "registrations": "Registreringar",
    "last30Days": "senaste 30 dagar",
    "trends": "Trender",
    "date": "Datum",
    "newUsers": "Nya användare",
    "rounds": "Rundor",
    "featureUsage": "Funktionsanvändning",
    "ebirdieUsage": "eBirdie-användare",
    "socialFeatures": "Användare av sociala funktioner",
    "paceTracking": "Spårtakt",
    "weeklyCompetitions": "Användare av veckotävlingar",
    "payments": "Betalande användare",
    "timePeriod": "Tidsperiod",
    "days7": "7 dagar",
    "days14": "14 dagar",
    "days30": "30 dagar",
    "days90": "90 dagar",
    "noData": "Ingen data tillgänglig",
    "error_load": "Det gick inte att ladda data"
  }
}
